import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import Swal from "sweetalert2";

//Filters
export const differenceInDays = (date1: Date, date2: Date): number => {
  const oneDay = 24 * 60 * 60 * 1000;
  const diffDays = Math.ceil(((date1.getTime() - date2.getTime()) / oneDay));
  return diffDays;
}

export const getEndOfWeek = (date: Date): Date => {
  let endOfWeek = new Date(date);
  endOfWeek.setDate(date.getDate() + (7 - date.getDay()));
  return endOfWeek;
}

export const getEndOfNextWeek = (date: Date): Date => {
  let endOfNextWeek = new Date(date);
  endOfNextWeek.setDate(date.getDate() + (14 - date.getDay()));
  return endOfNextWeek;
}

export const thisWeek = (activity: any): boolean => {
  const today = new Date();
  const endOfWeek = getEndOfWeek(today);
  const activityDate = new Date(activity.attributes.field_date_range.end_value);
  return activityDate <= endOfWeek;
}

export const nextWeek = (activity: any): boolean => {
  const today = new Date();
  const endOfWeek = getEndOfWeek(today);
  const endOfNextWeek = getEndOfNextWeek(today);
  const activityDate = new Date(activity.attributes.field_date_range.end_value);
  return activityDate > endOfWeek && activityDate <= endOfNextWeek;
}

export const nextMonth = (activity: any): boolean => {
  const today = new Date();
  const difference = differenceInDays(today, new Date(activity.attributes.field_date_range.end_value));
  return difference > 30;
}

export const isDatePast = (dateStr: string): boolean => {
  const inputDate = new Date(dateStr);
  const currentDate = new Date();
  inputDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  return inputDate < currentDate;
}

export const daysUntilDue = (date: string | Date): number => {
  const dueDate = new Date(date);
  const today = new Date();
  return Math.ceil((dueDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

//Forms

// Función para obtener un control de un formulario
export const getControl = (form: FormGroup, fieldName: string): FormControl => {
  return form.get(fieldName) as FormControl;
}

export const emailFormatValidator = (control: AbstractControl) => {
  const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

  if (!control.value.match(emailRegex)) {
    return { invalidEmailFormat: true };
  }
  return null;
}

export const getErrorMessage = (formControl: FormControl, min?: string, max?: string): string => {
  if ((formControl.dirty || formControl.touched) && formControl.hasError('required')) {
    return 'Este campo es obligatorio';
  }

  if (formControl && formControl.hasError('minlength')) {
    return `El campo debe contener al menos ${min} caracteres`;
  }

  if (formControl && formControl.hasError('email')) {
    return `La información ingresada no corresponde a un correo electrónico`;
  }

  if (formControl && formControl.hasError('maxlength')) {
    return `El campo no debe contener más de ${max} caracteres`;
  }

  if (formControl && formControl.hasError('pattern')) {
    return 'El formato del campo es incorrecto';
  }

  if (formControl && formControl.hasError('range')) {
    return 'El valor debe estar entre 0 y 100';
  }

  return '';
}

//Alertas

export const successfulAction= (title: string, message: string): Promise<any> => {
  const iconColor = getComputedStyle(document.documentElement).getPropertyValue('--color-secundario').trim();
  return Swal.fire({
    title: title,
    // text: message,
    html: message,
    icon: 'success',
    iconColor,
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    confirmButtonText: 'Aceptar'
  });
}

export const errorAction= (title: string, message: string): Promise<any> => {
  return Swal.fire({
    title: title,
    text: message,
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    confirmButtonText: 'Aceptar'
  });
}

export const warningAction= (title: string, message: string): Promise<any> => {
  return Swal.fire({
    title: title,
    text: message,
    icon: 'warning',
    iconColor: '#ffcc00',
    showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-danger'
      },
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
  });
}
